// Validate email format
export function emailMatch(email: string): boolean {
    return !!email.match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
}

// Convert Django choices to Vuetify format
export function djangoChoicesToVuetify(
    choices: [string | number, string][]
): { value: string | number; text: string }[] {
    return choices.map(choice => ({ value: choice[0], text: choice[1] }));
}

// Format number without decimals
export function formatNumber(number: number | string): string | null {
    const parsed = typeof number === "string" ? parseFloat(number) : number;
    if (isNaN(parsed)) return null;

    return parsed.toLocaleString("de-DE", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
    });
}

// Format percentage with one decimal
export function formatPercentage(number: number | string): string | null {
    const parsed = typeof number === "string" ? parseFloat(number) : number;
    if (isNaN(parsed)) return null;
    return parsed.toLocaleString("de-DE", {
        minimumFractionDigits: 1,
        maximumFractionDigits: 1
    });
}

// Format a number for data exports in the German system (comma decimal,
// dot thousands separator), e.g. 1234.5 -> "1.234,50". Returns "" for
// empty/NaN input so non-numeric cells (labels) can be handled by the caller.
export function formatNumberForExport(
    value: number | string,
    maxDecimals = 2
): string {
    const parsed = typeof value === "string" ? parseFloat(value) : value;
    if (parsed === null || parsed === undefined || isNaN(parsed)) return "";
    return parsed.toLocaleString("de-DE", {
        minimumFractionDigits: 0,
        maximumFractionDigits: maxDecimals,
        useGrouping: true
    });
}